export default __webpack_public_path__ + "static/media/3.82aae1fb.jpg";